import API from "@/constant/API";
import axiosInstance from "@/utils/axios";
import { toDateTimeString } from "@/utils/dateUtils";
import { Box, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import AppModal from "../AppModal";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import LabelValue from "@/pages/components/LabelValue";
import RpIcon from "../RpIcon";
import AppLoadingButton from "../mui/LoadingButton";
import { useState } from "react";

interface Props {
  open: boolean;
  onClose?: () => void;
  record: any;
}

export default function Modal3DS({open, onClose, record}: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const _onApprove = async (approve) => {
    try {
      setLoading(true);
      await axiosInstance.post(API.CARD_3DS_APPROVE, {
        initiateActionId: record.initiateActionId,
        approve,
      });
      onClose();
    } finally {
      setLoading(false);
    }
  }

  // const _onReject = async 
  if (!record) return null;

  return (
    <AppModal open={open} onClose={onClose}>
      <SimpleHeader transparentBg={true} title={t('is_transaction_allowed')} backEnable={false} 
        leading={<RpIcon icon={'close'} size={20} clickable onClick={onClose} />} />
      
      <Box sx={{ padding: '16px' }}>
        <Stack spacing={2}>
          <LabelValue label={t("card_number")} value={`\u2022\u2022\u2022\u2022 ${record.last4}`} />
          <LabelValue label={t("amount")} value={record.transactionAmount} />
          <LabelValue label={t("currency")} value={record.transactionCurrency} />
          <LabelValue label={t("merchant_name")} value={record.merchantName} />
          <LabelValue label={t("request_time")} value={toDateTimeString(record.transactionTimestamp)} />
        </Stack>

        <Stack spacing={2} sx={{ paddingTop: '20px' }}>
          <AppLoadingButton loading={loading}
            fullWidth size="large" variant="contained" onClick={() => _onApprove(true)}>{t('approve')}</AppLoadingButton>
          <AppLoadingButton loading={loading} 
            fullWidth size="large" onClick={() => _onApprove(false)}>{t('decline')}</AppLoadingButton>
        </Stack>
      </Box>
    </AppModal>
  );
}
